<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.sxfPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.sxfPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.sxfPay.application_title") }}
                </v-col>
              </v-row>
              <!-- sxfpay_org_id -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.sxfPay.sxfpay_org_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.sxfPay.sxfpay_org_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.sxfpay_org_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'sxfpay_org_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- sxfpay_mno -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.sxfPay.sxfpay_mno") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.sxfPay.sxfpay_mno')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.sxfpay_mno"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'sxfpay_mno')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- sxfpay_private_key -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.sxfPay.sxfpay_private_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.sxfPay.sxfpay_private_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.sxfpay_private_key"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'sxfpay_private_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- sxfpay_public_key -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.sxfPay.sxfpay_public_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.sxfPay.sxfpay_public_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.sxfpay_public_key"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'sxfpay_public_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.sxfPay.sxfpay_enable") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.sxfpay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getSxfFromAPI();
  },
  methods: {
    getSxfFromAPI() {
      Payment.fetch({
        keys: [
          "sxfpay_org_id",
          "sxfpay_mno",
          "sxfpay_private_key",
          "sxfpay_public_key",
          "sxfpay_enable",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.sxfpay_enable == null ||
              typeof this.settings.sxfpay_enable == "undefined" ||
              this.settings.sxfpay_enable == undefined
            ) {
              this.settings.sxfpay_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.SxfSave(this.settings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>